export default {
  /**
   *  @type {string} 検索画面
   */
  search: '/admin/users/',
  /**
   * 参照画面
   * @param {string} id 会員ID
   */
  refer: (id) => {
    return `/admin/users/refer/${id}`;
  },
};
